package de.ohhhmhhh.frontend.admin.ui.components.inputs

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.keywords.auto
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.TextInput

@Composable
fun SearchInput(search: String?, onSearch: (String?) -> Unit) {
    TextInput(search ?: "") {
        classes("form-control")
        placeholder("Suchen...")
        onInput { onSearch(it.value.ifBlank { null }) }
        style { width(auto) }
    }
}